export function flexibleContent() {
    let container = document.querySelector('main.site-content')

    if(!container){
        return
    }

    let flexible_content = container.querySelector('.flexible__content:last-of-type');

    if(!flexible_content){
        return
    }

    flexible_content.classList.add('last')
}